import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/buyers";
type PurchasePopupProps = {
  raised: boolean;
};
export function PurchasePopup({
  raised
}: PurchasePopupProps) {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer: number;
    const cycle = (i: number, delay: number) => {
      timer = window.setTimeout(() => {
        setIndex(i);
        setVisible(true);
        timer = window.setTimeout(() => {
          setVisible(false);
          cycle((i + 1) % buyers.length, 9000);
        }, 5000);
      }, delay);
    };
    cycle(0, 6000);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  const buyer = buyers[index];
  const initials = buyer.name.replace("Dr. ", "").split(" ").map(p => p[0]).join("");
  return <div className={`pointer-events-none fixed left-3 right-3 z-50 transition-[bottom] duration-200 ease-out sm:right-auto md:left-6 ${raised ? "bottom-[92px]" : "bottom-4 md:bottom-6"}`} aria-live="polite" data-id="element-262" data-mp="164oae88wa7v8">
      <AnimatePresence data-id="element-263" data-mp="1fxmylp0hbweb">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full items-center gap-3 rounded-2xl border border-navy-900/10 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(10,26,63,0.4)] sm:w-[340px]" data-id="element-264" data-mp="1ay0p9qnrv0as">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-navy-900 text-sm font-bold text-brand-cyan" data-id="element-265" data-mp="28jeskf3vyvce">{initials}</span>
            <div className="min-w-0" data-id="element-266" data-mp="23npnxxd0eo98">
              <p className="text-sm leading-snug text-ink" data-id="element-267" data-mp="2apcr8yu90zhe">
                <strong data-id="element-268" data-mp="2aqxjuix068cm">{buyer.name}</strong> from <strong data-id="element-269" data-mp="2fmv2ivvqnqsk">{buyer.country}</strong> just purchased the Ortho Case Command Center™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-cta" data-id="element-270" data-mp="2knsid1ta08qw">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-271" data-mp="2pm3ujj71mvca" />
                Verified purchase · {buyer.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:text-ink" aria-label="Dismiss notification" data-id="element-272" data-mp="1rw8v96tk6ajm">
              <XIcon className="h-4 w-4" data-id="element-273" data-mp="26oaqgdkoofdb" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}